import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

export interface CheckboxOption {
  value: string;
  label: string;
}

@Component({
  selector: 'app-exclusive-checkbox',
  templateUrl: './exclusive-checkbox.component.html',
  styleUrls: ['./exclusive-checkbox.component.css']
})
export class ExclusiveCheckboxComponent implements OnInit {

  @Input() options: CheckboxOption[] = [];
  @Output() selectionChange = new EventEmitter<string | null>();

  selectedValue: string | null = null;

  ngOnInit(): void {
    // Todos desmarcados al inicio
    this.selectedValue = null;
  }

  onCheckboxChange(value: string): void {
    if (this.selectedValue === value) {
      // Si se marca el mismo, se desmarca (toggle)
      this.selectedValue = null;
      this.selectionChange.emit(null);
    } else {
      // Selecciona el nuevo y desmarca el anterior
      this.selectedValue = value;
      this.selectionChange.emit(value);
    }
  }

  isChecked(value: string): boolean {
    return this.selectedValue === value;
  }
}
